import { useState } from 'react';
import styles from './AddDocument.module.css';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';

import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';

import UploadBox from '../../components/UploadBox/UploadBox';
import { FaFileAlt } from 'react-icons/fa';
import RadioGroupComponent from '../../components/RadioGroupComponent/RadioGroupComponent';

const AddDocument = () => {
  const [mediaType, setMediaType] = useState('File');
  const [uploadedFile, setUploadedFile] = useState(null);
  const dispatch = useDispatch();

  const handleSave = () => {
    console.log('Saved file:', uploadedFile);
  };

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleCancel = () => {
    setUploadedFile(null);
  };

  return (
    <div className={styles.cardContainer}>
      {/* Header */}
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<FaFileAlt />}
          heading="Add Document"
          color="var(--Primary_Color)"
        />
        <ToClose onClose={handleClose} />
      </div>

      {/* Body */}
      <div className={styles.body}>
        <div className={styles.formGroup}>
          <RadioGroupComponent
            label="Media Type *"
            name="mediaType"
            options={[
              { label: 'File', value: 'File' },
              { label: 'Photo', value: 'Photo' },
            ]}
            selectedValue={mediaType}
            onChange={(e) => setMediaType(e.target.value)}
          />
        </div>
        <div className={styles.formGroup}>
          <UploadBox
            onChange={(e) => setUploadedFile(e.target.files[0])}
            label="Upload File / document"
            innerLabel="Browse and Upload Files from Device"
          />
        </div>

        <div className={styles.actions}>
          <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
        </div>
      </div>
    </div>
  );
};

export default AddDocument;
